import { RSAA } from 'redux-api-middleware';

const GET_AZURE_SAS_REQUEST = 'GET_AZURE_SAS_REQUEST';
const GET_AZURE_SAS_SUCCESS = 'GET_AZURE_SAS_SUCCESS';
const GET_AZURE_SAS_FAILURE = 'GET_AZURE_SAS_FAILURE';

export const getAzureSas = (templateId: string, fileName: string) => ({
  [RSAA]: {
    types: [GET_AZURE_SAS_REQUEST, GET_AZURE_SAS_SUCCESS, GET_AZURE_SAS_FAILURE],
    endpoint: `/azure-sas/${templateId}/${fileName}`,
    method: 'GET',
  },
});
